module.exports = __webpack_public_path__ + "static/media/amfi.f822e900.jpg";